import { role } from "./roleReducer";

export default role;